export default {"src":"/_next/static/media/Group 427321040.7a6505fe.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};